export default {
      id: "hexagonal-usage",
      viewBox: "0 0 30 26",
      url: __webpack_public_path__ + "icons.svg#hexagonal",
      toString: function () {
        return this.url;
      }
    }